import React, { useCallback, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import "./shareReQuote.scss";
import UserImg from "../../assets/images/providerProfileImg.png";
import {
  CallIcon,
 LocationIcon,
 } from "../../components/Icons";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { jobId, setLoader } from "../../slice/commonSlice";
import {
  approveRejectJob,
  calculateTax,
  calculateTaxByAmount,
  fetchJobDetails,
  shareReQuote,
} from "../../services/auth.service";
import { convertDateFormat, fetchImage, getFullName, twoDecimalPlaces } from "../../utils/common";
import moment from "moment";
import { toast } from "react-toastify";
import { toast_error, toast_success } from "../../config/Constant";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import InlineItemForm from "./InlineItemForm";

const ShareReQuote = () => {
  const dispatch = useDispatch();
  const [isSame, setIsSame] = useState(false);
  const [details, setDetails] = useState({});
  const [providerDes, setProviderDes] = useState("");
  const [jobTime, setJobTime] = useState(null);
  let id = useSelector(jobId);

  const [inlineItem, setInlineItem] = useState([]);
  const [calculatedData, setCalculatedData] = useState({});
  const [inlineTotal, setInlineTotal] = useState(null);

  const [jobRate, setJobRate] = useState(null);
  const [fixedPrice, setFixedPrice] = useState(null);

  const navigate = useNavigate();

  const [files, setFiles] = useState([]);
  const [profileUrl, setProfileUrl] = useState(null);


  const onDrop = useCallback((acceptedFiles) => {
    // Handle the dropped files
    setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, []);
  const timeOptions = [
    { id: 1, value: 0.5, label: "30 Minutes" },
    { id: 2, value: 1, label: "1 Hour" },
    { id: 3, value: 1.5, label: "1 Hour 30 Minutes" },
    { id: 4, value: 2, label: "2 Hours" },
    { id: 5, value: 2.5, label: "2 Hours 30 Minutes" },
    { id: 6, value: 3, label: "3 Hours" },
    { id: 7, value: 3.5, label: "3 Hours 30 Minutes" },
    { id: 8, value: 4, label: "4 Hours" },
    { id: 9, value: 4.5, label: "4 Hours 30 Minutes" },
    { id: 10, value: 5, label: "5 Hours" },
    { id: 11, value: 5.5, label: "5 Hours 30 Minutes" },
    { id: 12, value: 6, label: "6 Hours" },
    { id: 13, value: 6.5, label: "6 Hours 30 Minutes" },
    { id: 14, value: 7, label: "7 Hours" },
    { id: 15, value: 7.5, label: "7 Hours 30 Minutes" },
    { id: 16, value: 8, label: "8 Hours" },
    { id: 17, value: 8.5, label: "8 Hours 30 Minutes" },
    { id: 18, value: 9, label: "9 Hours" },
    { id: 19, value: 9.5, label: "9 Hours 30 Minutes" },
    { id: 20, value: 10, label: "10 Hours" },
    { id: 21, value: 10.5, label: "10 Hours 30 Minutes" },
    { id: 22, value: 11, label: "11 Hours" },
    { id: 23, value: 11.5, label: "11 Hours 30 Minutes" },
    { id: 24, value: 12, label: "12 Hours" },
  ];

  useEffect(() => {
    if (id) {
      fetchJob();
    }
  }, [id]);
  const fetchJob = async () => {
    let payload = {
      id: id,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchJobDetails(payload);
      await dispatch(setLoader(false));
      let [job] = response.data?.jobData;
      setDetails(job);
      setCalculatedData({
        charge: job?.calculatedPrice,
        taxAmount: job?.taxAmount,
        total: job?.finalPrice,
      });

      if (job?.userId?.profilePic) {
        try {
          const imageUrl = await fetchImage(job.userId.profilePic)
          setProfileUrl(imageUrl)
        } catch (e) {
          console.error(e.message)
        }
      } else {
        setProfileUrl(UserImg)
      }

      setJobTime(job?.durationExpected);
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      if (isSame) {
        setCalculatedData({
          charge: details?.calculatedPrice,
          taxAmount: details?.taxAmount,
          total: details?.finalPrice,
        });
      } else {
        if (inlineItem?.length > 0) {
          if (
            details?.jobType === "moving" ||
            details?.jobType === "delivery"
          ) {
            if (jobRate === "fixed" && fixedPrice) {
              fetchTaxByAmount(Number(fixedPrice) + inlineTotal);
            } else {
              fetchTaxByAmount(calculatedData?.charge + inlineTotal);
            }
          } else {
            let res;
            if (jobRate === "fixed" && fixedPrice) {
              res = await fetchTaxByAmount(Number(fixedPrice));
            } else {
              res = await fetchTax(details?.unitPrice, jobTime);
            }
            let chargePayload = fixedPrice ? Number(fixedPrice) : res?.charge;
            fetchTaxByAmount(chargePayload + inlineTotal);
          }
        } else {
          if (
            details?.jobType === "moving" ||
            details?.jobType === "delivery"
          ) {
            if (jobRate === "fixed" && fixedPrice) {
              fetchTaxByAmount(Number(fixedPrice));

              // setCalculatedData({
              //   charge: res?.res?.finalAmount - res?.taxAmount,
              //   taxAmount: res?.taxAmount,
              //   total: res?.finalAmount,
              // });
            } else {
              setCalculatedData({
                charge: details?.calculatedPrice,
                taxAmount: details?.taxAmount,
                total: details?.finalPrice,
              });
            }
          } else {
            if (details?.durationExpected != jobTime) {
              if (jobRate === "fixed" && fixedPrice) {
                fetchTaxByAmount(Number(fixedPrice));
              } else {
                fetchTax(details?.unitPrice, jobTime);
              }
            }
          }
        }
      }
    };
    fetchData();
  }, [jobTime, isSame, inlineTotal, jobRate, fixedPrice]);

  const formatDateTime = (date) => {
    if (date) {
      const inputDate = moment.utc(date);
      const formattedDate = inputDate.format("h:mm A, DD MMMM, YYYY");
      return formattedDate;
    } else {
      return "";
    }
  };

  const handleIsSame = () => {
    if (!isSame) {
      setProviderDes("");
      setJobTime(details?.durationExpected);
      setFixedPrice(null)
      setJobRate(null)
    }
    setIsSame(!isSame);
  };

  const handleJobTime = (val) => {
    setJobTime(val);
    if (jobRate === "fixed" && fixedPrice) {
      fetchTaxByAmount(Number(fixedPrice));
    } else {
      if (details?.unitPrice) {
        fetchTax(details?.unitPrice, val);
      }
    }
  };

  const fetchTax = async (unitPrice, time) => {
    let payload = {
      unitPrice: unitPrice,
      durationExpected: time,
    };
    await dispatch(setLoader(true));
    try {
      const response = await calculateTax(payload);
      await dispatch(setLoader(false));
      if (response?.data?.status) {
        if (inlineItem?.length > 0) {
          return response.data;
        } else {
          setCalculatedData(response.data);
        }
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const fetchTaxByAmount = async (price) => {
    let payload = {
      amount: price,
    };
    await dispatch(setLoader(true));
    try {
      const response = await calculateTaxByAmount(payload);
      await dispatch(setLoader(false));
      setCalculatedData({
        charge: price,
        taxAmount: response?.data?.taxAmount,
        total: response?.data?.finalAmount,
      });

    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!jobTime) {
      toast.error("Please select job expected time", toast_error);
      return;
    }
    if (!jobRate) {
      toast.error("Please select job price rate", toast_error);
      return;
    }
    if (jobRate === "fixed" && !fixedPrice) {
      toast.error("Please add fiexd price amount", toast_error);
      return;
    }
    let total;
    const formData = new FormData();
    formData.append("jobId", details?._id);
    if (!isSame) {
      formData.append("quoteDescription", providerDes);
      formData.append("lineItemsData", JSON.stringify(inlineItem));
      if (
        inlineItem?.length > 0 ||
        calculatedData?.charge != details?.unitPrice
      ) {
        total = calculatedData?.charge;
        formData.append("updatedTotal", total);
        formData.append("lineItemsTotal", inlineTotal);
      }else{
        total = calculatedData?.charge;
        formData.append("updatedTotal", total);
      }
      formData.append("durationUpdated", jobTime);

      if (files?.length > 0) {
        files.forEach((file) => {
          formData.append("quoteFiles", file);
        });
      }
      if (fixedPrice) {
        formData.append("fixedPrice", fixedPrice);
      }
    }

    let payload = {
      "jobId": id,
      "requestStatus": 'accepted'
    }


    await dispatch(setLoader(true));
    try {
      await approveRejectJob(payload);
      const response = await shareReQuote(formData);

      await dispatch(setLoader(false));
      if (response?.status) {
        toast.success(response?.data?.message, toast_success);
        navigate(-1);
      }
    } catch (error) {
      toast.error(error?.data?.message, toast_error);
      await dispatch(setLoader(false));
      console.error("Error data:", error);
    }
  };


  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*",
    multiple: true,
  });
  const validate = () => {
    if (isSame) {
      return false;
    } else {
      if (!providerDes) {
        return true;
      } else {
        return false;
      }
    }
  };
  return (
    <>
      <Header />
      <PageHeading title="Share Re-Quote" />
      <div className="main-container">
        <div className="share-re-quote-wrapper">
          <div className="share-date-time-wrap">
            <div className="share-date-title">Date & Time:</div>
            <div className="share-date-time">
              {convertDateFormat(details?.startTime)}
            </div>
          </div>
          <div className="share-by-wrapper">
            <div className="share-user-wrap">
              <div className="share-user-img-wrap">
                <img src={profileUrl} alt="User" />
              </div>
              <div className="share-service-name">
                <div className="service-name">
                  {details?.serviceId?.name || details?.serviceName}
                </div>
                <div className="service-name-user">
                  {getFullName(
                    details?.userId?.firstName,
                    details?.userId?.lastName
                  )}
                </div>
              </div>
            </div>
            <div className="share-divider"></div>
            <div className="share-location-wrap">
              <div className="service-name bold">
                Job Location
              </div>
              <div className="share-location">
                <div className="icon-wrap">
                  <LocationIcon />
                </div>
                <div className="share-location-text">
                  {details?.userJobLocation}
                </div>
              </div>
              <div className="share-phone">
                <div className="icon-wrap">
                  <CallIcon />
                </div>
                <div className="share-phone-text">
                  {details?.userId?.phone ? details?.userId?.phone : "NA"}
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div className="job-rate">
            <div>
              <Form.Label>Job Rate</Form.Label>
              <Form.Select
                aria-label="Default select example"
                value={jobRate}
                onChange={(e) => setJobRate(e.target.value)}
              >
                <option>Select Job Rate</option>
                <option value="fixed">Fixed</option>
                <option value="hourly">Hourly</option>

              </Form.Select>
            </div>
            {jobRate === "fixed" ? (
              <div className="fixed-rate">
                <Form.Group>
                  <Form.Label>Fixed Price Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="fixedPrice"
                    placeholder="Fixed Price"
                    value={fixedPrice}
                    onChange={(e) => setFixedPrice(e.target.value)}
                  />
                </Form.Group>
              </div>
            ) : null}
          </div>
          <div className="w-100">
            <Form.Label>User details</Form.Label>
            <Form.Control
              rows={10} as="textarea"
              value={details?.jobDetail}
              disabled
              placeholder="User details"
            />
          </div>
          <div className="w-100">
            <div className="d-flex justify-content-between">
              <Form.Label>Provider Details</Form.Label>
              <Form.Check
                type="checkbox"
                id="customer"
                label="Same as customer"
                value={isSame}
                onChange={() => handleIsSame()}
              />
            </div>
            {!isSame ? (
              <Form.Control
                as="textarea"
                value={providerDes}
                onChange={(e) => setProviderDes(e.target.value)}
                rows={10}
                placeholder="Details"
              />
            ) : null}
          </div>

          {/* {details?.jobType !== "moving" && details?.jobType !== "delivery" ? ( */}
          <div className="w-100">
            <Form.Label>Expected job duration?</Form.Label>
            <Form.Select
              aria-label="Default select example"
              value={jobTime}
              onChange={(e) => handleJobTime(e.target.value)}
            >
              <option>Select the job expected time</option>
              {timeOptions?.map((item, index) => (
                <option key={index} value={item?.value}>
                  {item?.label}
                </option>
              ))}
            </Form.Select>
          </div>

          {!isSame ? (
            <div className="w-100">
              <div className="box-wrapper browse">

                <div>
                  <div
                    {...getRootProps()}
                    className={`dropzone ${isDragActive ? "active" : ""}`}
                  >
                    <input {...getInputProps()} />
                    <p>Drag & drop some files here, or click to select files</p>
                  </div>
                  {files.length > 0 && (
                    <div>
                      <h4>Selected Files:</h4>
                      <ul>
                        {files.map((file) => (
                          <li key={file.name}>{file.name}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : null}
          {!isSame ? (
            // <div className='w-100'>
            //   {
            //     inputList.map((x, i) => {
            //       return (
            //         <div key={i} className='add-item-row'>
            //           <div className='item-field'>
            //             <Row className='g-3'>
            //               <Col xs={6}>
            //                 <Form.Label>Item Name</Form.Label>
            //                 <Form.Control
            //                   type="text"
            //                   name='itemName'
            //                   placeholder="Item name here"
            //                   value={x.itemName}
            //                   onChange={(e) => handleInputChange(e, i)}
            //                 />
            //               </Col>
            //               <Col xs={6}>
            //                 <Form.Label>Item Price</Form.Label>
            //                 <Form.Control
            //                   type="number"
            //                   name="price"
            //                   value={x.price}
            //                   placeholder="Price here"
            //                   onKeyDown={(e) => handleUpdateInline(e)}
            //                   onChange={(e) => handleInputChange(e, i)}
            //                 />
            //               </Col>
            //             </Row>
            //           </div>

            //           {inputList.length !== 1 &&
            //             <div className='action-btn' onClick={() => handleRemoveClick(i)}>
            //               <RemoveIcon />
            //             </div>}
            //           {inputList.length - 1 === i && <div className='action-btn' onClick={handleAddClick}> <AddIcon /></div>}
            //         </div>
            //       )
            //     })
            //   }
            // </div>
            <InlineItemForm
              setInlineItem={setInlineItem}
              setInlineTotal={setInlineTotal}
            />
          ) : null}
          {/* <div className='w-100'>
            <div className='add-item-row'>
              <div className='item-field'>
                <Row className='g-3 '>
                  <Col xs={6}> <Form.Label>Item Name</Form.Label>
                    <Form.Control type="text" placeholder="Item name here" /></Col>
                  <Col xs={6}> <Form.Label>Item Price</Form.Label>
                    <Form.Control type="text" placeholder="Price here" /></Col>
                </Row>
              </div>
              <div className='action-btn'>
                <AddIcon />
              </div>
            </div>
          </div> */}

          <div className="payment-detail-wrap">
            <table className="table">
              <tr>
                <td width="800">Amount</td>
                <td width="140">{`${twoDecimalPlaces(calculatedData?.charge)
                  ? `$${twoDecimalPlaces(calculatedData?.charge)}`
                  : "-"
                  }`}</td>
              </tr>
              <tr>
                <td>Time</td>
                <td>{`${twoDecimalPlaces(jobTime)
                  ? `${twoDecimalPlaces(jobTime)} hr`
                  : "-"
                  }`}</td>
              </tr>
              <tr>
                <td>Helpr app fee & Transaction fee</td>
                <td>{`${twoDecimalPlaces(calculatedData?.taxAmount)
                  ? `$${twoDecimalPlaces(calculatedData?.taxAmount)}`
                  : "-"
                  }`}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td>{`${twoDecimalPlaces(calculatedData?.total)
                  ? `$${twoDecimalPlaces(calculatedData?.total)}`
                  : "-"
                  }`}</td>
              </tr>
            </table>
          </div>

          <div className="d-grid">
            <Button variant="primary" onClick={handleSubmit}>
              Share with Customer
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ShareReQuote;
